import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ToastMsg from "../../components/common/ToastMsg";
import { ImagePaths } from "../../utils/ImagePaths";
import useApiMethods from "../../lib/useApiMethods";
import { CHANGE_PASSWORD } from "../../constants/api";
import { Input } from "../../components/ui/input";
import { AuthSubmitButton, FormLabel, PasswordField } from "../../components/ui/form-fields";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { create } = useApiMethods();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const id = state?.id || 0;
  const user_name = state?.user_name || "";
  const email = state?.email || "";

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      ToastMsg("error", "Please fill in all fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      ToastMsg("error", "Passwords do not match");
      return;
    }

    if (newPassword.length < 6) {
      ToastMsg("error", "Password must be at least 6 characters");
      return;
    }

    setLoading(true);

    try {
      const payload = { new_password: newPassword, re_enter_password: confirmPassword, user_id: id, email };
      const response = await create(CHANGE_PASSWORD, payload, false, setLoading);

      if (response?.status === "success") {
        ToastMsg("success", response.message || "Password reset successfully");
        navigate("/PasswordSuccess", { state: { user_name: response.user_name || user_name } });
      } else {
        ToastMsg("error", response.message || "Failed to reset password");
      }
    } catch (error) {
      ToastMsg("error", error.message || "Unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center relative bg-background font-sans">
      <div
        className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/1462401298/photo/reset-password-successful-concept-lock-icon-security-code-showing-on-change-password-page-on.jpg?s=1024x1024&w=is&k=20&c=PN0bXj7Hfc0zncGaFYQGYjKbsc4gibWHaD0Hf5Nl0pE=')] bg-cover bg-center opacity-10"
      />
      <div className="absolute inset-0 bg-white/40 dark:bg-black/40 backdrop-blur-sm" />

      <div className="w-full max-w-sm relative z-10">
        <div className="flex justify-center mb-6">
          <img
            src={ImagePaths.loginLogo}
            alt="App Logo"
            className="h-10 w-auto animate-fadeIn"
          />
        </div>

        <div className="bg-card/95 backdrop-blur-md rounded-xl shadow-xl p-6 animate-fadeIn border border-border">
          <div className="flex items-center mb-4">
            <img
              src={ImagePaths.backArrow}
              alt="Back"
              className="h-5 w-5 cursor-pointer mr-2"
              onClick={() => navigate("/otpverification", { state: { id, email } })}
            />
            <h2 className="text-lg font-semibold text-foreground">
              Reset Your Password
            </h2>
          </div>
          <p className="text-sm text-muted-foreground text-center mb-5">
            Set a new password for your account
          </p>

          <form onSubmit={onSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <FormLabel htmlFor="username">Username</FormLabel>
              <Input
                id="username"
                type="text"
                value={user_name}
                readOnly
                className="bg-muted/50"
                placeholder="Username"
              />
            </div>

            <PasswordField
              id="new_password"
              label="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              placeholder="New Password"
            />

            <PasswordField
              id="confirm_password"
              label="Re-enter Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              placeholder="Re-enter Password"
            />

            <AuthSubmitButton
              loading={loading}
              loadingText="Resetting Password..."
              disabled={!newPassword || !confirmPassword}
            >
              Reset Password
            </AuthSubmitButton>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
